import { asignarIdsMenu } from '@/functions/general.js';
import { FRONTEND_V2 } from '@/config';
const menu = [
  {
    id: 'home',
    text: 'Dashboard',
    icon_img: 'home.svg',
    tabs:[
      { text: 'Principal', id:'main' },
      { text: 'Gestión BCEI y CSP', id:'management_ca_sp', permission:30 },
      { text: 'PRT & EA', id:'ptr_ea'/* , only_dev:true  */, permission:31},
      { text: 'Metricas', id:'metrics', permission:32 },
      { text: 'EBITDA por año fiscal', id:'ebit', permission:33 },
      /* { text: 'Issues de auditorias old', id:'issues_old' }, */
      { text: 'Issues de auditorias', id:'issues', permission:34 },
      /* { text: 'Hallazgos', id:'findings' }, */
      { text: 'KRI', id:'kri', permission:35 },
    ],
  },
  {
    id: 'my_management',
    text: 'Mi Gestión',
    icon: 'face',
    requires_ai_business_partner: true,
    tabs:[
      { text: 'Pendientes', id:'pending' },
    ],
  },
  {
    id: 'ca',
    text: 'BCEI',
    icon_img: 'equipo.svg',
    tabs:[
      { text: 'Listado oficial de BCEI', id:'official_list' },
      { text: 'Modos de Falla Catastróficas', id:'catastrophic_risk_analysis_official' },
      { text: 'Solicitud en proceso', id:'pending', permission:36 },
      { text: 'Histórico de solicitudes', id:'historical', permission:37 },
      { text: 'Histórico desactivado', id:'historical_disabled', permission:38 },
      { text: 'Simulaciones', id:'simulations', permission:24 },
      { text: 'Formulario de nuevos BCEI', id:'new', params:[]},
      { text: 'Formulario de BCEI', id:'edit', params:['id']},
      { text: 'Vista de BCEI', id:'view', params:['id']},
      { text: 'Revisión de BCEI', id:'review', params:['id']},
      { text: 'Formulario de nueva simulación de BCEI', id:'new_sim', params:[]},
      { text: 'Formulario de simulación BCEI', id:'edit_sim', params:['id']},
      { text: 'Revisión de BCEI', id:'edit_review', params:['id']},
    ],
  },
  {
    id: 'sp',
    text: 'CSP',
    icon_img: 'repuesto.svg',
    tabs:[
      { text: 'Listado oficial de CSP', id:'official_list' },
      { text: 'Solicitud en proceso', id:'pending', permission:39 },
      { text: 'Histórico de solicitudes', id:'historical', permission:40 },
      { text: 'Histórico desactivado', id:'historical_disabled', permission:41 },
      { text: 'Simulaciones', id:'simulations', permission:24  },
      /* { text: 'Simulaciones old', id:'simulations2', permission:24  }, */
      { text: 'Formulario de nuevos repuestos', id:'new', params:[]},
      { text: 'Formulario de repuestos', id:'edit', params:['id']},
      { text: 'Vista de repuestos', id:'view', params:['id']},
      { text: 'Revisión de repuestos', id:'review', params:['id']},
      { text: 'Formulario de nueva simulación de repuestos', id:'new_sim', params:[]},
      { text: 'Formulario de simulación de repuestos', id:'edit_sim', params:['id']},
      { text: 'Revisión de repuestos', id:'edit_review', params:['id']},
    ],
  },
  {
    id: 'findings',
    text: 'Hallazgos',
    icon_img: 'hallazgos.svg',
    /* only_dev:true, */
    permission:26,
    tabs:[
      { text: 'Listado oficial de hallazgos', id:'official_list' },
      { text: 'Mapa de Hallazgos', id:'finding_map', permission:50},
      { text: 'Higiene de Datos', id:'count_findings', permission:49 },
      { text: 'Hallazgos en proceso', id:'pending' },
      /* { text: 'Histórico de hallazgos', id:'historical' }, */
      { text: 'Hallazgos finalizados', id:'finished' },
      { text: 'Simulaciones', id:'simulations', permission:29},
      { text: 'Hallazgos eliminados', id:'removed_findings', permission:46},
      
      { text: 'Formulario de hallazgos', id:'new', params:[]},
      { text: 'Formulario de hallazgos', id:'edit', params:['id']},
      { text: 'Vista de hallazgos', id:'view', params:['id']},
      { text: 'Revisión de hallazgos', id:'review', params:['id']},
      { text: 'Editar hallazgos', id:'edit_steps', params:['k','id']},
      { text: 'Formulario de nueva simulación de hallazgos', id:'new_sim', params:[]},
      { text: 'Formulario de re-inspección de hallazgo', id:'re_inspec', params:[]},
    ],
  },
  {
    id: 'spci',
    text: 'SPCI',
    icon_img: 'spci.svg',
    /* only_dev:true, */
    permission:51,
    tabs:[
      { text: 'SPCI', id:'official_list',permission:51 },
      { text: 'Formulario de SPCI', id:'new', params:[],permission:52},
      { text: 'Formulario de SPCI', id:'edit', params:['id'],permission:53},
      { text: 'Vista de SPCI', id:'view', params:['id']},
    ],
  },
  {
    id: 'status',
    text: 'Status',
    icon_img: 'status.svg',
    /* only_dev:true, */
    permission:27,
    tabs:[
      { text: 'Dashboard', id:'dashboard' },
      { text: 'Fiscal year', id:'fiscal_year' },
      { text: 'EBITDA por año fiscal', id:'ebit_by_fiscal_year' },
      { text: 'Engineering Assessment', id:'ptr_ea' },
      { text: 'Estandares', id:'standars' },
      { text: 'Política de asset integrity', id:'asset_policy' },
      { text: 'BCEI', id:'critical_assets' },
      { text: 'CSP', id:'spare_parts' },
    ],
  },
  {
    id: 'monitoring',
    text: 'Monitoreo',
    icon_img: 'monitoring.svg',
    permission:28,
    /* only_dev:true, */
    tabs:[
      { text: 'Sistema de Monitoreo Remoto', id:'critical_asset'},
      { text: 'Informes Semanales', id:'online_monitoring_reports'},
      { text: 'Monitoreo', id:'detail', params:['critical_asset','name']},
    ],
  },
  {
    id: 'admin',
    text: 'Configuraciones',
    icon_img: 'config.svg',
    permission:12,
    tabs:[
      { text: 'Estándares', id:'standars', permission:12 },
      { text: 'Tracking de actividades de usuarios', id:'tracking', permission:12 },
      { text: 'Solicitudes', id:'requests', permission:12 },
      { text: 'Años fiscales', id:'fiscal_years', permission:12 },
      { text: 'EBITDA', id:'ebits', permission:12 },
      { text: 'Política AIMS', id:'aims', permission:12 },
      { text: 'Reportes', id:'backlog', permission:43 },
      { text: 'Clase de asset', id:'asset_class', permission:12, href: `${FRONTEND_V2}/settings/asset_class` },
      { text: 'Riesgos Materiales', id:'bowtie', permission:12, href: `${FRONTEND_V2}/settings/bowties` },
    ],
  },
  {
    id: 'frontend_v2_user_management',
    text: 'Usuarios',
    icon_img: 'employees.svg',
    href: `${FRONTEND_V2}/user_management/users`,
    permission: 12,
  },
  {
    id: 'frontend_v2_risk_index',
    text: 'Índice de Riesgos',
    icon_img: 'fire.svg',
    href: `${FRONTEND_V2}/risk_index_bceis`,
    permission_code: 'access_risk_index',
  },
  {
    id: 'frontend_v2_asset_health',
    text: 'Salud de Activos',
    icon_img: 'chart-bar.svg',
    href: `${FRONTEND_V2}/salud_activos`,
    permission_code: 'access_asset_health',
  },
  {
    id: 'frontend_v2_fmeca',
    text: 'FMECA',
    icon_img: 'archive.svg',
    href: `${FRONTEND_V2}/fmecas`,
    permission_code: 'access_fmeca',
  },
  {
    id: 'frontend_v2_audit_downloads',
    text: 'Auditoría',
    icon_img: 'download.svg',
    href: `${FRONTEND_V2}/logs/downloads`,
    permission_code: 'access_audit',
  },
  {
    id: 'frontend_v2_investigations',
    text: 'Gestión de Información ante eventos reales ASI',
    icon_img: 'clipboard.svg',
    href: `${FRONTEND_V2}/investigations`,
    permission_code: 'access_investigations',
  },
  {
    id: 'frontend_v2_my_profile',
    text: 'Mi Perfil',
    icon: 'account_circle',
    href: `${FRONTEND_V2}/my_profile`,
  },
];
asignarIdsMenu(menu);
export default menu;
